import React from 'react';

export default () => {
  return (
    <footer className="page-footer black center-align">
      <div className="footer-copyright">
        <div className="container">© 2025 Jengo LLC, All rights reserved.</div>
      </div>
    </footer>
  );
};
